import parse from "html-react-parser"

import { cn } from "@/lib/utils"

type CourseListProps = React.HTMLAttributes<HTMLUListElement> & {
  data?: string[] | string | null
  renderItem?: (item: string, index: number) => React.ReactNode
}

function normalizeData(data: string[] | string | null | undefined): string[] {
  if (Array.isArray(data)) return data
  if (typeof data === "string" && data.length > 0) return [data]
  return []
}

export function CourseList({ data, renderItem, className, ...props }: CourseListProps) {
  const items = normalizeData(data)

  return (
    <ul className={cn("flex list-disc flex-col gap-2 pl-5 sm:pl-8", className)} {...props}>
      {items.map((item, index) => (
        <li key={item} className="text-base sm:text-lg">
          {renderItem ? renderItem(item, index) : parse(item)}
        </li>
      ))}
    </ul>
  )
}
